/* lettra: Produktschriften — finale Namen (24.7.2026): Eigenname + Deskriptor,
   nie Font-Name. Reihenfolge seriös → verspielt, Trennlinie nach GRAT
   (Druck → Handschrift). Eine Quelle für Konfigurator, Hero und Ideen-Grid. */
/* verbunden: Die Glyphen beruehren sich und verschmelzen im Druck zu einem
   Teil. Steht seit 28.7.2026 bei allen zehn Schriften auf false — lettra hat
   derzeit KEINE verbundene Schrift.

   Der Grund ist gemessen: Bei einer verbundenen Schrift muss das ganze Wort
   auf die Druckplatte, nicht nur der einzelne Buchstabe. "Emma" war bei 15 cm
   Versalhoehe 435 mm breit, bei 250 mm nutzbarer Breite passen dort zwei
   Zeichen; "Familie Huber" bei 20 cm ergab 1,27 m. Verbundene Schriften
   gehoeren deshalb in ein eigenes Produkt mit begrenzter Zeichenzahl.

   sperre: Zeichen, fuer die es in dieser Schrift KEIN brauchbares Bauteil
   gibt — in jeder Groesse. Seit dem 2. 9. 2026 ist die Liste LEER, und das
   Feld bleibt trotzdem stehen: es ist der Ort, an dem ein defektes Bauteil
   eingetragen wird, ohne dass jemand erst die Mechanik dafuer bauen muss.

   Was hier vom 1. bis 2. 9. 2026 stand und warum es weg ist:
     ç      fehlte in ~/lettra-stl-v3 vollstaendig (masse.csv fuehrte
            c_cedille_klein.stl, die 40 Dateien waren am 6. 8. um 16:05 nach
            dem Lauf geloescht worden). In ~/lettra-stl-v4 neu gebaut, in
            allen zehn Schriften geslict: wasserdicht, ein Teil, keine
            Warnung.
     Ç      war in SEIDE non-manifold, weil die Cedille der Italiana gegen
            das C laeuft und Blender die Ueberlappung ausschnitt. Der neue
            Generator vereinigt sie; geslict bei 5, 10 und 15 cm ohne
            Warnung. Bei 20 cm passt das Zeichen nicht aufs Bett — das ist
            eine Groessengrenze und steht in sperre20, nicht hier. Ç ist im
            Konfigurator ohnehin nicht im Zeichenvorrat.
     Ø ø Q 8  waren nie defekt. Zwei Befunde vom 1. 9., die sie als falsch
            gefuellt fuehrten, waren Fehler in meiner Vergleichskontur, nicht
            im STL.
   Schriftbezogen, nicht global. Gross- und Kleinschreibung zaehlen.
   Ausgewertet in lettra-configurator.js (hartGesperrteZeichen): kein
   Warenkorb, solange ein eingetragenes Zeichen im Text steht.

   Das Feld bleibt als Dokumentation stehen: Es haelt fest, welche Eigenschaft
   eine Schrift haben kann, und ist der Ort, an dem eine kuenftige
   Verbindungsschrift markiert wuerde. Ausgewertet wird es aktuell nirgends —
   die mehrteilige Lieferung ist ersatzlos entfallen.
   Bewusst ein eigenes Feld und NICHT aus der Rasterposition oder der
   Trennlinie nach GRAT abgeleitet: Die Trennlinie sortiert Druck- gegen
   Handschrift, das ist eine visuelle Gruppierung. CARA und TINTA sehen
   handschriftlich aus, ihre Buchstaben beruehren sich aber nicht.

   sperre20: Zeichen, die bei 20 cm nicht mehr aufs Druckbett (256 mm) passen.
   Die Groessenangabe gilt fuer die Grossbuchstaben, das Bauteil ist groesser —
   runde Versalien ueberschiessen um 3 %, Umlaute um 31 %. Die Listen stammen
   aus echten Slicer-Tests aller 760 Zeichenkombinationen, sie sind nicht
   gerechnet und aendern sich nur bei anderem Schriftschnitt oder Drucker.
   Gross- und Kleinschreibung zaehlen: Bei ATRIO ist das kleine m gesperrt,
   das grosse M nicht.
   Als Feld an der Schrift und nicht als eigene Tabelle — so wird es bei einer
   elften Schrift automatisch mitgedacht.

   SEIDE traegt seit 28.7.2026 Italiana, eine schmale Antiqua ohne
   Verbindungen. Vorher war es eine Kalligrafie-Schrift mit sehr breiten
   Versalien; damit faellt beides weg — das verbunden-Flag und die vier
   gesperrten Zeichen. Ebenfalls in Bambu Studio geprueft. */
window.LETTRA_FONTS = [
  { name: 'ELDA',   desc: 'Klassisch und ruhig',        css: "'Libre Baskerville',serif", w: 700, verbunden: false, sperre20: ['M', 'Q', 'W', 'm'], sperre: [] },
  { name: 'VIENNE', desc: 'Elegant, festlich',          css: "'Playfair Display',serif",  w: 700, verbunden: false, sperre20: ['Q', 'W'],           sperre: [] },
  { name: 'NORD',   desc: 'Klar und schlicht',          css: "'Inter',sans-serif",        w: 600, verbunden: false, sperre20: ['W'],                sperre: [] },
  { name: 'ATRIO',  desc: 'Modern, geradlinig',         css: "'Montserrat',sans-serif",   w: 800, verbunden: false, sperre20: ['W', 'm', 'w'],      sperre: [] },
  { name: 'GRAT',   desc: 'Schmal und kräftig',         css: "'Bebas Neue',sans-serif",   w: 400, verbunden: false, sperre20: [],                   sperre: [], divider: true },
  { name: 'SEIDE',  desc: 'Fein und aufrecht',          css: "'Italiana',serif",          w: 400, verbunden: false, sperre20: [],                   sperre: [] },
  { name: 'NOA',    desc: 'Locker geschwungen',         css: "'Courgette',cursive",       w: 400, verbunden: false, sperre20: [],                   sperre: [] },
  { name: 'CARA',   desc: 'Wie mit Stift geschrieben',  css: "'Caveat',cursive",          w: 700, verbunden: false, sperre20: [],                   sperre: [] },
  { name: 'TINTA',  desc: 'Schwungvoll, wie gepinselt', css: "'Mansalva',cursive",        w: 400, verbunden: false, sperre20: [],                   sperre: [] },
  { name: 'BOLLA',  desc: 'Rund und verspielt',         css: "'Baloo 2',cursive",         w: 800, verbunden: false, sperre20: ['W'],                sperre: [] },
];
window.lettraFontByName = function (name) {
  return window.LETTRA_FONTS.find(function (f) { return f.name === name; }) || window.LETTRA_FONTS[0];
};
